import { css } from '@/styled-system/css';

export const layoutContentStyles = css.raw({
  display: 'grid',
  padding: 'default',
  borderRadius: 'obj.default',
  backgroundColor: 'bg.neutral',
});
